import { render, staticRenderFns } from "./news.vue?vue&type=template&id=2f130a70&"
import script from "./news.vue?vue&type=script&lang=js&"
export * from "./news.vue?vue&type=script&lang=js&"
import style0 from "./news.vue?vue&type=style&index=0&id=2f130a70&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports